<!-- eslint-disable max-len -->

<template>
  <a-card>
    <a-row type="flex" align="middle" justify="space-between" :gutter="10">
      <a-col class="col-center space-between"
        ><span class="title">YouTube Channel</span>
        <a-input-search v-model:value="search.q" class="search-input ml-24" placeholder="Search" @input="loadData"
      /></a-col>
      <a-col class="col-center space-between">
        <div><span>Type:</span></div>
        <a-select
          v-model:value="search.type"
          :getPopupContainer="(trigger) => trigger.parentNode"
          class="source-select"
          default-value=""
          @change="loadData"
        >
          <a-select-option value=""> All Types </a-select-option>
          <a-select-option value="All messages"> All messages </a-select-option>
          <a-select-option value="Matched keyword"> Matched keyword </a-select-option>
        </a-select>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <!-- Table will be here -->
        <TableSetting
          :rowKey="'_id'"
          :isRowSelection="true"
          :isActionDropDown="true"
          :isTotalActive="true"
          :isTimeFromNow="true"
          :tableData="filteredSourceList"
          :columns_props="columnConfig"
          :actions="actions"
          :pagination="{
            showQuickJumper: false,
            showSizeChanger: true,
            total: filteredSourceList.length,
            showTotal: () => '',
          }"
          @toggleAction="onToggleAction"
        />
      </a-col>
    </a-row>
    <EditYoutubeChannel
      :visible="editPageVisible"
      :channel-info="channelInfo"
      @close="resetEditData"
      @success="resetEditData"
    ></EditYoutubeChannel>

    <ConfirmDelete :visible="confirmVisible" @close="confirmVisible = false" @confirm="deleteChannel">
      Are you sure delete this channel?
    </ConfirmDelete>
    <ConfirmDelete :visible="confirmMultipleVisible" @close="confirmMultipleVisible = false" @confirm="deleteMultiple">
      Are you sure delete multiple channels?
    </ConfirmDelete>
  </a-card>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue';
import EditYoutubeChannel from './EditYoutubeChannel.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import api from '@/services/api';
import { useStore } from 'vuex';
import TableSetting from '@/components/Table/TableSetting.vue';
import { notification } from 'ant-design-vue';
import helper from '@/services/helper';

export default {
  components: { EditYoutubeChannel, ConfirmDelete, TableSetting },
  setup() {
    const store = useStore();
    const channels = computed(() => store.getters['sourceSetting/youtubeChannels']);
    const confirmVisible = ref(false);
    const confirmMultipleVisible = ref(false);
    const editPageVisible = ref(false);
    const channelInfo = ref({});
    const search = reactive({
      q: '',
      type: '',
    });
    const columnConfig = [
      {
        title: 'Channel Name',
        dataIndex: 'channelName',
        key: 'channelName',
        slots: { customRender: 'source_name' },
        sorter: helper.getTableSortFn('string', 'channelName'),
      },
      {
        title: 'Data Collection',
        dataIndex: 'type_txt',
        key: 'type_txt',
        slots: { customRender: 'type' },
        sorter: helper.getTableSortFn('string', 'type_txt'),
      },
      {
        title: 'Date Added',
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        slots: { customRender: 'updated_at' },
        sorter: helper.getTableSortFn('date-x', 'updatedAt'),
        defaultSortOrder: 'descend',
      },
      {
        title: 'Actions',
        key: 'action',
        slots: { customRender: 'action' },
      },
    ];

    const actions = [
      { name: 'Open Link', value: 'open_link', icon: 'external-link' },
      { name: 'Edit', value: 'edit', icon: 'edit' },
      { name: 'Delete', value: 'delete', icon: 'trash-2' },
    ];

    const selectedData = ref(null);

    const loadData = async () => {
      await store.dispatch('sourceSetting/getYoutubeChannels');
    };

    const resetEditData = () => {
      editPageVisible.value = false;
      loadData();
    };

    const onEditPage = async (data) => {
      console.log(data);
      channelInfo.value = data;
      editPageVisible.value = true;
    };
    const confirmdeleteChannel = (data) => {
      confirmVisible.value = true;
      selectedData.value = data;
    };
    const deleteChannel = async () => {
      // delete api
      let result = await api.deleteYoutubeChannelByAccountId(selectedData.value.link).catch(() => {});
      if (result && result.code === 200) {
        notification.success({
          message: 'Success',
          description: `Channel ${selectedData.value.name} removed.`,
        });
      } else {
        notification.error({
          message: 'Error',
          description: `Channel ${selectedData.value.name} remove failed.`,
        });
      }
      confirmVisible.value = false;
      selectedData.value = null;
      loadData();
    };

    const confirmDeleteMultiple = (data) => {
      console.log([...data]);

      confirmMultipleVisible.value = true;
      selectedData.value = [...data];
      console.log('confirm delete multiple channels ...');
    };

    const deleteMultiple = async () => {
      const list = selectedData.value;
      let result = await api.bulkDeleteYoutubeChannel(list).catch(() => {});
      if (result && result.code === 200) {
        notification.success({
          message: 'Success',
          description: `${list.length} channels removed.`,
        });
      } else {
        notification.error({
          message: 'Error',
          description: `${list.length} channels remove failed.`,
        });
      }
      console.log('deleted channel...');
      confirmMultipleVisible.value = false;
      selectedData.value = null;
      loadData();
    };

    const filteredSourceList = computed(() => {
      let items = channels.value || [];
      if (items.length) {
        const searchTerm = search.q.trim();
        if (searchTerm) {
          items = items.filter((v) => v.channelName.toLowerCase().includes(searchTerm.toLowerCase()));
        }
        if (search.type) {
          items = items.filter((v) => v.type === search.type);
        }
      }
      return items;
    });

    const onToggleAction = ({ action, record }) => {
      if (action === 'edit') {
        onEditPage(record);
      } else if (action === 'delete') {
        confirmdeleteChannel(record);
      } else if (action === 'deleteMultiple') {
        confirmDeleteMultiple(record);
      } else if (action === 'open_link') {
        window.open(`https://www.youtube.com/channel/${record.id}`);
      }
    };

    onMounted(() => {
      loadData();
    });
    return {
      channels,
      confirmVisible,
      confirmMultipleVisible,
      editPageVisible,

      channelInfo,
      search,
      loadData,
      resetEditData,

      confirmdeleteChannel,
      deleteChannel,
      deleteMultiple,

      filteredSourceList,
      columnConfig,
      onToggleAction,
      actions,
    };
  },
};
</script>

<style scoped lang="scss">
.title {
  font-family: DM Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: '#272B41';
}

.search-input {
  border-radius: 18px;
  width: 250px;
  height: 36px;
}
.ml-24 {
  margin-left: 24px;
}

.col-center {
  display: flex;
  align-items: center;
  padding: 5px;
}
.source-select {
  width: 160px;
  margin-left: 8px;
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 540px) {
  .space-between {
    justify-content: space-between;
    flex: auto;
  }
}
.user-name {
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 9px;
}

.user-id {
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
}
</style>
